<script>
import { FaqWidget } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    let categoryOptions = {}
    let headerOptions = {}
    this.$store.state.languages.forEach(
      lang => (categoryOptions[lang.code] = headerOptions[lang.code] = [])
    )

    return {
      arrayFields: ['items'],
      categoryOptions,
      headerOptions
    }
  },
  mounted() {
    this.fetchCategoriesAndHeaders()
  },
  methods: {
    fetchCategoriesAndHeaders() {
      FaqWidget.getCategoriesAndHeaders().then(response => {
        const categories = response.data.categories
        const headers = response.data.headers
        const strArrToOptions = str => ({ label: str, value: str })
        this.$store.state.languages.forEach(lang => {
          this.categoryOptions[lang.code] = categories[lang.code].map(
            strArrToOptions
          )
          this.headerOptions[lang.code] = headers[lang.code].map(
            strArrToOptions
          )
        })
      })
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Select({
              label: 'Nagłówek',
              modelPath: [this, 'form', 'headers'],
              required: true,
              multiple: true,
              filterable: true,
              allowCreate: true,
              multilingual: true,
              options: this.headerOptions[this.currentLanguage]
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['header_pl']),
                fields: [
                  new fields.Input({
                    label: 'Nagłówek',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'header'],
                    multilingual: true
                  }),
                  new fields.Input({
                    label: 'Tekst',
                    type: 'textarea',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'text'],
                    multilingual: true
                  }),
                  new fields.Select({
                    label: 'Funkcje',
                    modelPath: [this, 'form', 'items', i, 'categories'],
                    multiple: true,
                    filterable: true,
                    allowCreate: true,
                    multilingual: true,
                    options: this.categoryOptions[this.currentLanguage]
                  })
                ]
              }))
            })
          ]
        }
      ]
    },
    currentLanguage() {
      return this.$store.state.selectedLanguage
    }
  }
}
</script>
